import type { ResourceChangeSet } from '@seen/core/queued-edits/model'
import { getResourceModelName } from '@seen/core/registry/registry'
// getResourceModelName reads the model registry, which the registry entry
// populates; the root barrel used to load it as a side effect.
import '@seen/core/registry/index'
import type { JSX } from 'react'
import { Tooltip } from '#src/components/core/tooltip/Tooltip.tsx'
import { TooltipContent } from '#src/components/core/tooltip/TooltipContent.tsx'
import { TooltipTrigger } from '#src/components/core/tooltip/TooltipTrigger.tsx'
import { ResourceIcon } from '#src/components/ResourceIcon.tsx'

// The resource icon, hover-revealing the most specific Seen model type (e.g.
// "SDR Signature", "Intervention") when identifiable, else the FHIR resource
// type. Helps reviewers tell apart the many resources that share a FHIR type
// (Tasks especially).
export function ResourceTypeIcon({
  change,
}: {
  change: ResourceChangeSet
}): JSX.Element {
  const typeName = change.resource
    ? getResourceModelName(change.resource)
    : change.resourceType
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="flex shrink-0 items-center">
          {change.resource ? (
            <ResourceIcon
              resource={change.resource}
              className="size-4 text-muted-foreground"
            />
          ) : (
            <ResourceIcon
              resourceType={change.resourceType}
              className="size-4 text-muted-foreground"
            />
          )}
        </span>
      </TooltipTrigger>
      <TooltipContent>{typeName}</TooltipContent>
    </Tooltip>
  )
}
